import React, { Component } from 'react';
import IntroSlider from '../introSlider';
import HowToGet from '../howToGet';
import HowToGetHolidays from '../howToGetHolidays';
import WeAreWorking from '../weAreWorking';
import HowToExam from '../howToGet/howtoExam';
import MostAskedQuestions from '../MostAskedQuestion/MostAskedQuestions';
import Footer from '../footer/Footer';
import ClentForm from '../clientform/ClientForm';
import './layout.scss';
class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onSelectCityHandler: '',
      isMobile: false,
    };
  }

  componentDidMount() {
    const windowWidth = window.innerWidth;

    if (windowWidth && windowWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      onSelectCityHandler: props.onSelectCityHandler,
    });
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div className="layout">
        <IntroSlider onEaster2={this.props.onEaster2} />
        <WeAreWorking />
        <HowToGet cityHandler={this.state.onSelectCityHandler} />
        <HowToGetHolidays />
        <ClentForm />
        <HowToExam />
        <MostAskedQuestions />
        <Footer />
      </div>
    );
  }
}

export default Layout;
